function init() {
    const videoTuts = document.querySelectorAll('#recent-video-tutorials article');
    const videoCors = document.querySelectorAll('#recent-video-courses article');

    function createThumbnail(video, i) {
        const videoIMG = video[i].querySelector('.img');
        const videoURL = video[i].getAttribute('attr-video-url');

        if ( RegExp('vimeo*', 'g').test(videoURL) ) {
            let xmlhttp = new XMLHttpRequest();
            let videoID = videoURL.replace('https://vimeo.com/', '');

            xmlhttp.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    const videoThumb = JSON.parse(this.responseText)[0].thumbnail_large;
                    videoIMG.setAttribute('style', 'background-image: url(' + videoThumb + ')');
                }
            };
            xmlhttp.open("GET", 'https://vimeo.com/api/v2/video/' + videoID + '.json', true);
            xmlhttp.send();

        } else if ( RegExp('wistia*', 'g').test(videoURL) ) {
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    const videoThumb = JSON.parse(this.responseText).thumbnail_url;
                    videoIMG.setAttribute('style', 'background-image: url(' + videoThumb + ')');
                }
            };
            xmlhttp.open("GET", 'https://fast.wistia.com/oembed?url=' + videoURL, true );
            xmlhttp.send();
        } else {
            videoIMG.setAttribute('style', 'background-image: url(/wp-content/themes/givinghelpdesk/assets/build/img/static.webp)');
        }
    }
    
    for (i=0; i < videoTuts.length; i++) {
        createThumbnail(videoTuts, i);
    }
    for (i=0; i < videoCors.length; i++) {
        createThumbnail(videoCors, i);
    }
}
module.exports = { init };